import { IComponentOptions, IController } from 'angular';
import { UploadingFile } from '../../attachment-upload-btn/uploading-file';
import { IUploadFileResult } from '../../../core/interfaces/upload-file-response.interface';
import { ApiService } from '../../../core/services/api-service/api.service';
import { isObject } from 'lodash-es';
import './attachment-uploader-modal.component.scss';

export interface IAttachmentModalResult {
  successFiles: UploadingFile[];
  errorFiles: UploadingFile[];
}

export interface IAttachementUploadModalData {
  files?: File[];
  invalidFiles: File[];
  uploadUrl?: string;
}

export class AttachmentUploaderModalCtrl implements IController {
  static $inject = [
    'ApiService'
  ];
  onClose: ( data: { result: any } ) => void;
  data: IAttachementUploadModalData;
  uploadingFiles: UploadingFile[] = [];
  uploading = false;
  uploadedCount = 0;
  successUploadedFiles: UploadingFile[] = [];
  errorUploadedFiles: UploadingFile[] = [];

  constructor( private apiService: ApiService ) {

  }

  $onInit() {
    if ( this.data.files && this.data.files.length ) {
      this.data.files.forEach(( file ) => this.uploadingFiles.push(new UploadingFile(file)));
    }
  }

  closeModal() {
    this.onClose({ result: false });
  }

  startUpload() {
    this.uploadFiles();
  }

  private uploadFiles() {
    this.uploading = true;
    this.uploadingFiles.forEach(( file ) => {
      const data = { file: file.file };
      this.apiService.upload(this.data.uploadUrl, data)
        .then(( res ) => {
          if ( isObject(res.data) ) {
            file.result = res.data as IUploadFileResult;
            this.successUploadedFiles.push(file);
          }
        }, ( errRes ) => {
          file.error = errRes;
          this.errorUploadedFiles.push(file);
        }, ( event ) => {
          if ( !file.error ) {
            const percent = 100 * event.loaded / event.total;
            file.updateProgress(percent);
          }
        })
        .finally(() => {
          this.uploadedCount += 1;
          if ( this.uploadedCount === this.uploadingFiles.length ) {
            const result: IAttachmentModalResult = {
              successFiles: this.successUploadedFiles,
              errorFiles: this.errorUploadedFiles
            };
            this.onClose({ result });
          }
        });
    });
  }
}

export const AttachmentUploaderModalComponent: IComponentOptions = {
  controller: AttachmentUploaderModalCtrl,
  template: require('./attachment-uploader-modal.component.html'),
  bindings: {
    data: '<',
    onClose: '&'
  }
};



// WEBPACK FOOTER //
// ./app/components/modals/attachment-uploader-modal/attachment-uploader-modal.component.ts